export default __webpack_public_path__ + "scripts/resources/assignments/en/chemvlab/stoichiometry/chloride_ga/species.json";